import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const MaterialListCmp_AllMaterials_QueryDocument = graphql(`
  query MaterialListCmp_AllMaterials_Query {
    findAllMaterials {
      _id
      code
      label
      statusId
    }
  }
`);

export type MaterialListCmp_Material = ResultOf<
  typeof MaterialListCmp_AllMaterials_QueryDocument
>['findAllMaterials'][number];

export const useFindAllMaterialsQuery = (enabled = true) =>
  useGraphQLQuery(MaterialListCmp_AllMaterials_QueryDocument, undefined, {
    enabled,
  });
